import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrphanedAssignmentService from '../../../../Services/OrphanedAssignmentService';
import OrphanedAssignmentsProjectGroupedByOfficeItem from '../../../../Domain/OrphanedAssignmentsProjectGroupedByOfficeItem';

export default class OrphanedAssignmentsProjectGroupedByOfficeAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OrphanedAssignmentsProjectGroupedByOfficeItem}
          serviceFunction={OrphanedAssignmentService.GetOrphanedAssignmentsProjectGroupedByOffice}
          convertDBItemsFunction={OrphanedAssignmentService.ConvertOrphanedAssignmentsProjectGroupedByOfficeDBItems}
          searchItem={{}}
          orderBy='AsSassieSurveyId'
          errorCode='OACPGBOA24'
        />
      </div>
    );
  }
}
